// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.VerifyLandlordIdentityWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { VerifyLandlordIdentityWebApiRequestDto } from '../..';

export const VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Path = '/api/web/v1/verifyLandlordIdentity';

/**
 * Verify landlord identity
 */
export const VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity = (
  postData: VerifyLandlordIdentityWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, VerifyLandlordIdentityWebApiRequestDto, void>(
    {
      endpoint: VerifyLandlordIdentityWebApiHandler_verifyLandlordIdentity_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
